/// <reference path="../../typings/tsd.d.ts" /> 
module warsApp.controllers {
    export interface IUserAdministrationScope extends angular.IScope {
        model: models.UserAdministrationModel
       }


    export class UserAdministrationController implements IController {
        constructor(
            private scope: IUserAdministrationScope,
            private filter: angular.IFilterService,
            private userAdministrationService : services.UserAdministrationService,
            private userService: services.UserService) {
            this.scope.model = new models.UserAdministrationModel(userAdministrationService, userService, filter);
        }
    }
}

warsApp.registerController('UserAdministrationController', ['$scope', '$filter', 'userAdministrationService', 'userService']);